import styled from 'styled-components';

const SVGMilestones = styled.div`
  position: relative;
  display: inline-block;
  overflow: hidden;
  height: ${props => (props.horizontal ? `${props.height}px` : '100%')};
  width: ${props => (props.horizontal ? `${props.width}px` : '100%')};
  padding-bottom: ${props =>
    props.horizontal ? `${props.height}px` : `${(props.height / props.width) * 100}%`};
  svg {
    display: inline-block;
    position: absolute;
    width: inherit;
    height: inherit;
  }
`;

export default { SVGMilestones };
